class StartAnimate {
    constructor(el) {
        this.el = el;
        this.isSHowed = true;
        this.listenEvents();
    }

    listenEvents() {
        window.addEventListener("scroll", () => {
            if (this.isSHowed) {
                const position = this.el.getBoundingClientRect();
                // checking whether fully visible
                if(position.top >= 0 && position.bottom <= window.innerHeight) {
                    this.el.classList.add("show-animation");
                    this.isSHowed = false;
                }
            }
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-start-animate")
        .forEach(input => new StartAnimate(input));
});
